import React, { useState, useEffect } from "react";
import axios from "axios";
import { TrendingUp, Plus, Trash2, CheckCircle2, X } from "lucide-react";

export const KeuanganPendapatanLainPage = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [notification, setNotification] = useState("");
  const [form, setForm] = useState({
    judul: "",
    kategori: "Pemasangan Baru",
    nominal: 250000,
    tanggal: new Date().toISOString().split("T")[0],
    diterima_dari: "",
    metode_bayar: "Transfer BCA",
    keterangan: ""
  });

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${BACKEND_URL}/api/pendapatan-lain`, {
        withCredentials: true
      });
      setList(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${BACKEND_URL}/api/pendapatan-lain`, form, {
        withCredentials: true
      });
      setNotification("Pendapatan lain berhasil dicatat!");
      setShowAdd(false);
      setForm({
        judul: "",
        kategori: "Pemasangan Baru",
        nominal: 250000,
        tanggal: new Date().toISOString().split("T")[0],
        diterima_dari: "",
        metode_bayar: "Transfer BCA",
        keterangan: ""
      });
      fetchData();
      setTimeout(() => setNotification(""), 4000);
    } catch (err) {
      alert("Gagal mencatat pendapatan");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Hapus data pendapatan ini?")) {
      try {
        await axios.delete(`${BACKEND_URL}/api/pendapatan-lain/${id}`, {
          withCredentials: true
        });
        fetchData();
      } catch (err) {
        alert("Gagal menghapus");
      }
    }
  };

  const totalNominal = list.reduce((acc, item) => acc + item.nominal, 0);

  return (
    <div className="space-y-6" data-testid="pendapatan-lain-page">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 p-5 rounded-2xl bg-[#0e1628] border border-slate-800 shadow-xl">
        <div>
          <div className="flex items-center gap-2">
            <span className="px-2 py-0.5 rounded bg-emerald-500/20 text-emerald-400 text-[10px] font-bold uppercase tracking-wider">
              Other Income
            </span>
            <span className="text-xs text-slate-400">Total: Rp {totalNominal.toLocaleString("id-ID")}</span>
          </div>
          <h1 className="text-xl sm:text-2xl font-black text-white mt-1">
            Pendapatan Lain Non-Tagihan
          </h1>
          <p className="text-xs text-slate-400 mt-0.5">
            Pencatatan biaya pemasangan baru, penjualan ONT router, sewa IP publik, dan jasa teknisi.
          </p>
        </div>

        <button
          onClick={() => setShowAdd(true)}
          data-testid="add-pendapatan-btn"
          className="px-4 py-2 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-500 hover:to-teal-500 text-white text-xs font-bold rounded-xl shadow-lg shadow-emerald-600/30 flex items-center gap-2 transition-all"
        >
          <Plus className="w-4 h-4" />
          <span>Tambah Pendapatan</span>
        </button>
      </div>

      {notification && (
        <div className="p-3 bg-emerald-500/10 border border-emerald-500/30 text-emerald-300 rounded-xl text-xs flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-emerald-400" />
          <span>{notification}</span>
        </div>
      )}

      {/* Table */}
      <div className="p-5 rounded-2xl bg-[#0e1628] border border-slate-800 shadow-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-xs">
            <thead>
              <tr className="border-b border-slate-800 text-slate-400 font-semibold">
                <th className="py-2.5 px-3">Tanggal Transaksi</th>
                <th className="py-2.5 px-3">Judul</th>
                <th className="py-2.5 px-3">Kategori</th>
                <th className="py-2.5 px-3">Diterima Dari</th>
                <th className="py-2.5 px-3">Metode Bayar</th>
                <th className="py-2.5 px-3">Nominal (IDR)</th>
                <th className="py-2.5 px-3 text-right">Aksi</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800/60">
              {list.map((item) => (
                <tr key={item.id} className="hover:bg-slate-900/40">
                  <td className="py-3 px-3 whitespace-nowrap" data-testid={`pendapatan-tanggal-${item.id}`}>
                    <span className="text-slate-200 font-medium">
                      {item.tanggal ? new Date(`${item.tanggal}T00:00:00`).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" }) : "-"}
                    </span>
                    <p className="text-[10px] text-slate-500 font-mono">{item.tanggal}</p>
                  </td>
                  <td className="py-3 px-3">
                    <p className="font-bold text-white">{item.judul}</p>
                    {item.keterangan && <span className="text-[10px] text-slate-400">{item.keterangan}</span>}
                  </td>
                  <td className="py-3 px-3">
                    <span className="px-2 py-0.5 rounded bg-emerald-500/15 text-emerald-300 font-medium text-[11px]">
                      {item.kategori}
                    </span>
                  </td>
                  <td className="py-3 px-3 text-slate-200">{item.diterima_dari}</td>
                  <td className="py-3 px-3 text-slate-300">{item.metode_bayar}</td>
                  <td className="py-3 px-3 font-mono font-bold text-emerald-400">
                    Rp {Number(item.nominal).toLocaleString("id-ID")}
                  </td>
                  <td className="py-3 px-3 text-right">
                    <button
                      onClick={() => handleDelete(item.id)}
                      className="p-1.5 text-rose-400 hover:bg-rose-950/60 rounded-lg"
                    >
                      <Trash2 className="w-3.5 h-3.5" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showAdd && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-[#0f172a] border border-slate-700 rounded-2xl w-full max-w-md shadow-2xl p-5 space-y-4">
            <div className="flex justify-between items-center border-b border-slate-800 pb-3">
              <h3 className="text-sm font-bold text-white">Catat Pendapatan Lain</h3>
              <button onClick={() => setShowAdd(false)} className="text-slate-400">
                <X className="w-4 h-4" />
              </button>
            </div>

            <form onSubmit={handleSave} className="space-y-3">
              <div>
                <label className="block text-xs text-slate-300 mb-1">Keterangan / Judul *</label>
                <input
                  type="text"
                  required
                  value={form.judul}
                  onChange={(e) => setForm({ ...form, judul: e.target.value })}
                  placeholder="Contoh: Registrasi Pasang Baru Bpk. Rahmat"
                  className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100"
                />
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs text-slate-300 mb-1">Kategori</label>
                  <select
                    value={form.kategori}
                    onChange={(e) => setForm({ ...form, kategori: e.target.value })}
                    className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100"
                  >
                    <option value="Pemasangan Baru">Pemasangan Baru</option>
                    <option value="Penjualan Router/Modem">Penjualan Router/Modem</option>
                    <option value="Jasa Tarik Kabel">Jasa Tarik Kabel</option>
                    <option value="Sewa IP Publik">Sewa IP Publik</option>
                    <option value="Lainnya">Lainnya</option>
                  </select>
                </div>

                <div>
                  <label className="block text-xs text-slate-300 mb-1">Tanggal Transaksi *</label>
                  <input
                    type="date"
                    required
                    value={form.tanggal}
                    onChange={(e) => setForm({ ...form, tanggal: e.target.value })}
                    data-testid="pendapatan-tanggal-input"
                    className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100"
                  />
                </div>

                <div>
                  <label className="block text-xs text-slate-300 mb-1">Nominal (Rp) *</label>
                  <input
                    type="number"
                    required
                    value={form.nominal}
                    onChange={(e) => setForm({ ...form, nominal: parseFloat(e.target.value) || 0 })}
                    className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100 font-mono"
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs text-slate-300 mb-1">Diterima Dari</label>
                  <input
                    type="text"
                    value={form.diterima_dari}
                    onChange={(e) => setForm({ ...form, diterima_dari: e.target.value })}
                    placeholder="Nama Pelanggan / Pihak"
                    className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100"
                  />
                </div>

                <div>
                  <label className="block text-xs text-slate-300 mb-1">Metode Bayar</label>
                  <select
                    value={form.metode_bayar}
                    onChange={(e) => setForm({ ...form, metode_bayar: e.target.value })}
                    className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100"
                  >
                    <option value="Transfer BCA">Transfer BCA</option>
                    <option value="QRIS">QRIS</option>
                    <option value="Cash / Tunai">Cash / Tunai</option>
                  </select>
                </div>
              </div>

              <div className="pt-2 flex justify-end gap-2">
                <button
                  type="button"
                  onClick={() => setShowAdd(false)}
                  className="px-3 py-1.5 bg-slate-800 text-slate-300 rounded-xl text-xs"
                >
                  Batal
                </button>
                <button
                  type="submit"
                  className="px-4 py-1.5 bg-emerald-600 text-white rounded-xl text-xs font-bold"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};
